import { usePlanningStore } from '@planning/AppProvider'
import { useTranslate } from '@tolgee/react'

// Must be called from an observer component so the label updates when the
// session gate binding changes (e.g. invalidated by a real-time gate update).
export const useSelectedGateLabel = (): string | undefined => {
  const { t } = useTranslate()
  const { gateSessionStore } = usePlanningStore()
  const gateName = gateSessionStore.boundGate?.name ?? gateSessionStore.boundGate?.code

  return gateName ? `${t('gate', 'Gate')}: ${gateName}` : undefined
}
